(function () {
    'use strict';

    var $doc = $(document);

    $doc.on('click', '[data-toggle="popel-tablecollapse"]', function (event) {
        event.preventDefault();

        var $this   = $(this),
            $target = $($this.attr('data-target') || $this.attr('href'));

        if (!$target || $target.length < 1) return true;

        var $table   = $target.find('.table-collapsable'),
            $trigger = $target.find('.table-collapse-trigger'),
            $content = $target.find('.table-collapse'),
            height   = $table.outerHeight(true);

        $target.css('height', height).addClass('collapsing');

        $trigger.css('position', 'absolute');
        $content.removeClass('d-none');

        // $table[0].offsetHeight;

        var targetHeight = $table.outerHeight(true);

        $trigger.css('position', '');

        // $trigger[0].offsetHeight;

        $target.css('height', targetHeight);

        // $target[0].offsetHeight;

        $trigger.removeClass('in');
        $content.addClass('in');

        var complete = function () {
            $trigger.addClass('d-none');
            $target.removeClass('collapsing');
            $target.css('height', '');
        };

        if (!$.support.transition) return complete();

        $target.one('bsTransitionEnd', complete).emulateTransitionEnd(500);
    });
})(window.jQuery);
